module.exports = __webpack_public_path__ + "static/media/highlightCenter_topView_hyperboloid.b687e5e8.png";